export enum STOCK_DEV_ACTION {
    LOAD_DATA_SETS = "LOAD_DATA_SETS",
    LOAD_USERS="LOAD_USERS",
}